<div class="tw-h-full">
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <form [formGroup]="formGroup" (submit)="submit()" class="tw-h-full tw-p-4">
    <div mat-dialog-title class="matp-dialog-title">
      位置情報設定{{ updating ? "編集" : "新規登録" }}
    </div>

    <mat-dialog-content
      class="tw-w-full !tw-pt-2 !tw-min-h-[calc(100%_-_100px)] tw-h-[calc(100%_-_100px)]"
    >
      <div class="tw-flex tw-gap-x-4 tw-h-full">
        <div
          class="tw-flex tw-flex-col tw-gap-y-6 tw-w-full tw-max-w-[27rem] tw-h-full"
        >
          <!-- 位置情報名 -->
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>位置情報名</mat-label>
            <input
              matInput
              formControlName="locationName"
              name="locationName"
            />
            <mat-error
              *ngIf="formGroup.controls.locationName.errors?.['required']"
            >
              位置情報名を入力してください。
            </mat-error>
            <mat-error
              *ngIf="formGroup.controls.locationName.errors?.['maxlength']"
            >
              100文字以下で入力してください。
            </mat-error>
          </mat-form-field>

          <!-- 位置情報住所 -->
          <div class="tw-flex tw-flex-col tw-gap-y-2">
            <mat-form-field
              appearance="outline"
              floatLabel="always"
              class="tw-w-full"
            >
              <mat-label>位置情報住所</mat-label>
              <input
                matInput
                formControlName="address"
                name="address"
                [matAutocomplete]="autocomplete"
              />
              <mat-autocomplete
                #autocomplete="matAutocomplete"
                [autoSelectActiveOption]="true"
                (optionSelected)="onSelectedPlace($event)"
              >
                @for (place of placeSuggestionList; track place.text) {
                  <mat-option [value]="place.text">
                    {{ place.text }}
                  </mat-option>
                }
              </mat-autocomplete>
              <mat-error
                *ngIf="formGroup.controls.address.errors?.['required']"
              >
                住所を入力してください。
              </mat-error>
              <mat-error
                *ngIf="formGroup.controls.address.errors?.['maxlength']"
              >
                100文字以下で入力してください。
              </mat-error>
              @if (!isUse) {
                <button
                  id="address-filter-clear-btn"
                  matSuffix
                  mat-icon-button
                  type="button"
                  (click)="clearAddress()"
                >
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>

            @if (!isUse) {
              <button
                id="search-btn"
                mat-raised-button
                color="primary"
                class="tw-w-40"
                type="button"
                [disabled]="formGroup.controls.address.invalid"
                (click)="searchPlaceSuggestionsList()"
              >
                <mat-icon>search</mat-icon>検索
              </button>
            }
          </div>

          <!-- ジオフェンス種類 -->
          <div>
            <div>ジオフェンス種類</div>
            <mat-radio-group color="primary" formControlName="geofenceType">
              <mat-radio-button value="circle" class="tw-mr-4"
                >円型</mat-radio-button
              >
              <mat-radio-button value="polygon">フリー描画</mat-radio-button>
            </mat-radio-group>
          </div>
          @if (formGroup.controls.geofenceType.value === "circle") {
            <div class="tw-flex tw-gap-x-2">
              <!-- 半径 -->
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="tw-w-full"
              >
                <mat-label>半径</mat-label>
                <input
                  matInput
                  formControlName="circleRadius"
                  name="circleRadius"
                  type="number"
                  min="1"
                  max="999"
                />
                @if (formGroup.controls.circleRadius.errors?.["radiusRange"]) {
                  <mat-error>
                    0より大きく100km未満の値を入れてください
                  </mat-error>
                } @else if (
                  formGroup.controls.circleRadius.errors?.["required"]
                ) {
                  <mat-error> 半径を入力してください。 </mat-error>
                } @else if (formGroup.controls.circleRadius.errors?.["min"]) {
                  <mat-error> 1以上の値を入力してください。 </mat-error>
                } @else if (formGroup.controls.circleRadius.errors?.["max"]) {
                  <mat-error> 999以下の値を入力してください。 </mat-error>
                }
              </mat-form-field>
              <!-- 単位 -->
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="tw-min-w-28 tw-max-w-28"
              >
                <mat-label>単位</mat-label>
                <mat-select formControlName="unit" name="unit">
                  <mat-option value="m"> m </mat-option>
                  <mat-option value="km"> km </mat-option>
                  <mat-option value="mile"> mile </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          } @else if (formGroup.controls.geofenceType.value === "polygon") {
            <!-- 頂点の数 -->
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>頂点の数</mat-label>
              <input
                matInput
                formControlName="numberOfVertices"
                name="numberOfVertices"
                type="number"
                min="3"
                max="5"
              />
              <mat-error
                *ngIf="formGroup.controls.numberOfVertices.errors?.['required']"
              >
                頂点の数を入力してください。
              </mat-error>

              <mat-error
                *ngIf="formGroup.controls.numberOfVertices.errors?.['min']"
              >
                3以上の値を入力してください。
              </mat-error>
              <mat-error
                *ngIf="formGroup.controls.numberOfVertices.errors?.['max']"
              >
                5以下の値を入力してください。
              </mat-error>
            </mat-form-field>
          }
          <div
            class="geofence-overlap-notice matp-error-message-panel tw-rounded tw-border tw-border-solid tw-p-3"
          >
            <div class="geofence-overlap-notice-heading">
              <mat-icon class="geofence-overlap-notice-icon">warning</mat-icon>
              <div class="geofence-overlap-notice-title">注意</div>
            </div>
            <ul class="geofence-overlap-notice-message">
              <li>
                ジオフェンスが重なると、予期しない動作になる可能性があります。<br />
                他のジオフェンスと重ならないように設定してください。<br />
              </li>
              <li>
                ジオフェンス外にデバイスがあり、<br />
                ジオフェンスの編集によって範囲内になった場合でも<br />
                位置情報として認識はできませんのでご了承ください<br />
                （次回ジオフェンスに入った際は認識できます）
              </li>
            </ul>
          </div>
        </div>

        <!-- マップ -->
        <div class="tw-w-full tw-min-h-full tw-h-full">
          <div class="tw-h-[calc(100%_-_30px)]">
            <!-- マップ表示 -->
            <app-shipment-location-map
              class="tw-w-full tw-min-h-full tw-max-h-full"
              mapId="dialog-map"
              [location]="shipmentLocation"
              [additionalLocationList]="displayRegisteredLocationList"
              [deviceLocationList]="deviceLocationList"
              [editable]="true"
              (polygonEdited)="setPolygonList($event)"
              (mapClicked)="setShipmentLocation($event)"
            ></app-shipment-location-map>
          </div>

          <!-- 登録済位置情報表示 -->
          <mat-slide-toggle
            color="primary"
            [checked]="isRegisteredLocationVisible"
            (change)="toggleRegisteredLocationListDisplay($event)"
          >
            登録済位置情報を表示する
          </mat-slide-toggle>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions
      class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4 tw-h-auto"
    >
      <button
        id="cancel-btn"
        mat-raised-button
        mat-dialog-close
        class="tw-w-40"
      >
        <mat-icon>close</mat-icon>
        キャンセル
      </button>
      <button
        id="edit-btn"
        mat-raised-button
        color="accent"
        class="tw-w-40"
        type="submit"
        [disabled]="formGroup.invalid"
      >
        <mat-icon>done</mat-icon>
        <span>{{ updating ? "変更" : "新規登録" }}</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>
